var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container keep-px"},[_c('web-header'),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1),_c('web-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }